module.exports = __webpack_public_path__ + "static/media/floral-silhouette-with-vines-and-leaves-variant-design-svgrepo-com.0061c2b1.svg";